import clsx from "clsx";

import { AdLabelMatches } from "@features/breakdown-v2/ad-label-matches";
import { type SegmentDescriptor } from "@north-beam/nb-common";
import { PrimaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";

interface Props {
  labelName: string;
  segments: SegmentDescriptor[];
  segment: SegmentDescriptor | null;
  onClose: () => void;
}

export const AdLabelMatchesModal = (props: Props) => {
  return (
    <Modal
      size="2xl"
      isOpen={!!props.segment}
      onClose={props.onClose}
      titleContent={
        <div className="flex heading gap-2 text-2xl mb-4">
          <strong>Matches: </strong>
          <span className="m-0 text-wrap">
            {props.labelName}
            {"  "}
            <i className="fa-regular fa-angle-right text-lg mt-0.5" />
            {"  "}
            {props.segment?.name}
          </span>
        </div>
      }
    >
      {props.segment ? (
        <Content {...props} />
      ) : (
        <div className="h-[60vh]"></div>
      )}
    </Modal>
  );
};

const Content = ({ segments, segment, onClose }: Props) => {
  return (
    <div>
      <AdLabelMatches segments={segments} segment={segment!} />
      <div className="flex items-center justify-end gap-2 mt-4">
        <PrimaryButton className="font-bold" onClick={onClose}>
          DISMISS
        </PrimaryButton>
      </div>
    </div>
  );
};
